export enum ENotificationEvents {
    'TOAST_NOTIFICATION' = 'toast_notification',
    'MODALS_NOTIFICATION' = 'modals_notification',
    'DISCONNECTED' = 'disconnect',
    'CONNECT_ERROR' = 'connect_error',
    'CONNECTED' = 'connect',
}
export const NOTIFICATION_PATH = '/notifier/ws';
export const MAX_RECONNECT_ATTEMPTS = 5;
